class CalendarHelper {
    static getMonths = (year) => {
        return [
            new Date(year, 8),
            new Date(year, 9),
            new Date(year, 10),
            new Date(year, 11),
            new Date(year+1, 0),
            new Date(year+1, 1),
            new Date(year+1, 2),
            new Date(year+1, 3),
            new Date(year+1, 4),
            new Date(year+1, 5),
            new Date(year+1, 6),
            new Date(year+1, 7),
        ]
    }

    static getDaysInMonths = (month, year) => (new Array(31)).fill('').map((v, i) => new Date(year, month - 1, i + 1)).filter(v => v.getMonth() === month - 1)
}

export default CalendarHelper